import http from '../http';

const campaignerApi = {
	subscribe(data) {
		return http.post('/campaigner-subscribe', data);
	}
}

export {
	campaignerApi
}